import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import clsx from 'clsx';
import { isDef } from '../utils';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';
import useLockScroll from '../hooks/use-lock-scroll';

var Overlay = function Overlay(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('overlay', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var nodeRef = useRef(null);
  var visible = props.visible,
      duration = props.duration;

  var _useLockScroll = useLockScroll(function () {
    return props.lockScroll;
  }),
      _useLockScroll2 = _slicedToArray(_useLockScroll, 2),
      lockScroll = _useLockScroll2[0],
      unlockScroll = _useLockScroll2[1];

  var innerLockRef = useRef(false);

  var renderOverlay = function renderOverlay() {
    var style = _objectSpread(_objectSpread({
      zIndex: props.zIndex !== undefined ? +props.zIndex : undefined,
      touchAction: props.lockScroll && 'none'
    }, props.style), props.customStyle);

    if (isDef(duration)) {
      style.animationDuration = "".concat(duration, "ms");
    }

    return /*#__PURE__*/React.createElement("div", {
      ref: nodeRef,
      style: style,
      onClick: props.onClick,
      className: clsx(bem(), props.className)
    }, props.children);
  };

  useEffect(function () {
    if (!props.lockScroll) return;

    if (visible) {
      lockScroll();
      innerLockRef.current = true;
    }

    if (!visible && innerLockRef.current) {
      unlockScroll();
      innerLockRef.current = false;
    }
  }, [visible]);
  useEffect(function () {
    return function () {
      if (props.lockScroll) unlockScroll();
    };
  }, []);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    nodeRef: nodeRef,
    mountOnEnter: true,
    unmountOnExit: true,
    in: visible,
    timeout: duration,
    classNames: "".concat(prefixCls, "-fade")
  }, renderOverlay());
};

Overlay.defaultProps = {
  lockScroll: true,
  duration: 300
};
export default Overlay;